const styles = theme => ({
  leftSideList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    borderRight: '1px solid #E0E0E0',
    padding: '0px 24px 0px 0px',
    [`@media (max-width: 1280px)`]: {
      display: 'none',
    },
  },
  leftSideListItem: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    padding: '8px',
    borderRadius: '8px',
    cursor: 'pointer',
    minWidth: '192px',
    '&:hover': {
      backgroundColor: '#E3F3FF',
    },
  },
  active: {
    backgroundColor: '#E3F3FF',
  },
  mobileSelect: {
    display: 'none',
    width: '100%',
    [`@media (max-width: 1280px)`]: {
      display: 'block',
    },
  },
  select: {
    width: '100%',
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    width: '100%',
    '& .MuiTypography-root': {
      flex: 1,
    },
  },
})

export default styles
